import React from 'react';
import { Link } from 'react-router-dom';

const TokenHelp = () => {
  return (
    <div className="token-help-page">
      <h1 className="mb-4">Entendiendo los Tokens</h1>
      
      <div className="alert alert-info mb-4">
        <i className="fas fa-info-circle me-2"></i>
        Los tokens son la base de nuestra economía en WintonCoin. A continuación encontrarás información sobre cómo funcionan.
      </div>
      
      <div className="row">
        <div className="col-md-6 mb-4">
          <div className="card h-100 border-primary">
            <div className="card-header bg-primary text-white">
              <h3>Token BLUE</h3>
            </div>
            <div className="card-body">
              <h5>¿Qué es?</h5>
              <p>El token BLUE es la moneda principal para pagar por tareas en la plataforma.</p>
              
              <h5>¿Cómo se obtiene?</h5>
              <ul>
                <li>Completando tareas para otros usuarios</li>
                <li>Participando en promociones y eventos</li>
                <li>Intercambiando con otras criptomonedas (próximamente)</li>
              </ul>
              
              <h5>¿Para qué sirve?</h5>
              <ul>
                <li>Pagar a colaboradores que completan tus tareas</li>
                <li>Ofrecer recompensas por trabajos</li>
                <li>Transferir valor entre usuarios</li>
              </ul>
            </div>
            <div className="card-footer">
              <Link to="/wallet" className="btn btn-outline-primary">Ver mis tokens BLUE</Link>
            </div>
          </div>
        </div>
        
        <div className="col-md-6 mb-4">
          <div className="card h-100 border-danger">
            <div className="card-header bg-danger text-white">
              <h3>Token RED</h3>
            </div>
            <div className="card-body">
              <h5>¿Qué es?</h5>
              <p>El token RED es un token de recompensa que recibes cuando pagas por tareas completadas.</p>
              
              <h5>¿Cómo se obtiene?</h5>
              <ul>
                <li>Se mintean automáticamente cuando pagas por una tarea</li>
                <li>Por cada 100 BLUE gastados, recibes 105 RED (5% extra)</li>
                <li>Participando en la gobernanza de la plataforma</li>
              </ul>
              
              <h5>¿Para qué sirve?</h5>
              <ul>
                <li>Acceder a servicios premium en la plataforma</li>
                <li>Recibir descuentos en comisiones</li>
                <li>Participar en decisiones de gobernanza (próximamente)</li>
              </ul>
            </div>
            <div className="card-footer">
              <Link to="/wallet" className="btn btn-outline-danger">Ver mis tokens RED</Link>
            </div>
          </div>
        </div>
      </div>
      
      <div className="card mb-4">
        <div className="card-header">
          <h3>Preguntas Frecuentes</h3>
        </div>
        <div className="card-body">
          <div className="accordion" id="tokenFaq">
            <div className="accordion-item">
              <h2 className="accordion-header">
                <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#faq1">
                  ¿Cómo puedo transferir tokens a otra wallet?
                </button>
              </h2>
              <div id="faq1" className="accordion-collapse collapse show">
                <div className="accordion-body">
                  Actualmente, los tokens están en la red de prueba. Próximamente habilitaremos la posibilidad de transferir tokens a wallets externas.
                </div>
              </div>
            </div>
            
            <div className="accordion-item">
              <h2 className="accordion-header">
                <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#faq2">
                  ¿Cuál es el valor de los tokens?
                </button>
              </h2>
              <div id="faq2" className="accordion-collapse collapse">
                <div className="accordion-body">
                  El valor de los tokens es determinado por el mercado y la utilidad dentro de la plataforma. Inicialmente, 1 BLUE = 1 RED en términos de utilidad, pero esto puede cambiar con el tiempo.
                </div>
              </div>
            </div>
            
            <div className="accordion-item">
              <h2 className="accordion-header">
                <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#faq3">
                  ¿Qué sucede si no tengo suficientes tokens BLUE para pagar una tarea?
                </button>
              </h2>
              <div id="faq3" className="accordion-collapse collapse">
                <div className="accordion-body">
                  Necesitarás obtener más tokens BLUE completando tareas o a través de otras formas de adquisición que estarán disponibles próximamente.
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <div className="text-center mt-4">
        <Link to="/tasks" className="btn btn-primary me-2">Explorar Tareas</Link>
        <Link to="/wallet" className="btn btn-outline-primary">Ver Mi Billetera</Link>
      </div>
    </div>
  );
};

export default TokenHelp;
